import "core-js/modules/es.promise.js";
import { nsnewo } from "../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
export const NewoDropMultiFileStatusHeader = props => {
  const {
    drop,
    title,
    common,
    status
  } = props;
  const {
    disabled
  } = common;
  const {
    open
  } = drop;
  const {
    removeAll
  } = status;
  const {
    t
  } = useTranslation(nsnewo.common);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "card-header pb-4 pb-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-7 pb-3 pb-xl-0 text-xl-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "card-title fw-semibold"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-5 text-xl-end pb-4 pb-xl-0 pe-xl-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "card-subtitle"
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-group",
    role: "group"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-pill border-secondary text-secondary px-4 py-2",
    onClick: open,
    disabled: disabled
  }, t('newo.documentalValidation.search'))))))));
};